import { render, staticRenderFns } from "./IdleDisplay.vue?vue&type=template&id=d4f35d24&"
import script from "./IdleDisplay.vue?vue&type=script&lang=js&"
export * from "./IdleDisplay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports